import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';

export interface StockItemHistory {

  status :String ;
  startDate : Date;
  endDate : Date;
  hardwareNumberOrder : number;
  licenseNumberOrder : number;

  swCategory : String;
  swType: String;
  swItem : String;

}




@Injectable({
  providedIn: 'root'
})
export class StockItemHistoryService {

  PATH = '/appliances/api/v2/stockItemHistory/';

  constructor(private httpClient: HttpClient) { }

  getStockItemHistory(id : number): any {

    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    
    return this.httpClient.get<StockItemHistory>(this.PATH + id , { headers })
    .pipe(catchError(this.errorHandler));
  }


  errorHandler(error: HttpErrorResponse) {
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }
}
